// extracted by mini-css-extract-plugin
export var body = "_c9-0";
export var sectionHeader = "_c9-4";
export var shortcutColumns = "_c9-2";
export var shortcutList = "_c9-1";
export var shortcutSection = "_c9-3";